import {useQuery} from "@tanstack/react-query";
import axios from "axios";
import {RoleMaster} from "../../../models/config/RoleMaster";
import {ResponseList} from "../../../models/common/Response";

export type UseRoleMasterProps = {
    sid?: string;
    id?: string;
    menuId?: string;
};

export function useRoleMaster(props?: UseRoleMasterProps) {
    const { sid, id, menuId } = props || {};
    
    return useQuery({
        queryKey: ['role-master', { sid, id, menuId }],
        queryFn: ({ signal }) => {
            const accessToken = localStorage.getItem('LG_APPLICATION');
            return axios.get<ResponseList<RoleMaster>>(
                '/v1/configuration/lis/role',
                {
                    signal,
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    },
                    params: {
                        sid,
                        id,
                        menu_id: menuId,
                    }
                }
            );
        },
        select: response => response.data.result_list,
        retry: 1
    });
}
